import React, { forwardRef } from 'react';
import { func, array, object } from 'prop-types';

import Event from '../Event/Event';
import { SECTIONS } from '../../constants';

import './EventsWrapper.scss';

const EventsList = ({
  arr,
  registerItemRef,
  evtType,
  shouldExpandByDefault,
  staticText,
}) =>
  arr.map((event) => (
    <Event
      shouldExpandByDefault={shouldExpandByDefault}
      key={event.id}
      evtType={evtType}
      itemRef={(el) => registerItemRef(SECTIONS.EVENT, event.id, el)}
      startTime={event.startTime}
      type={event.type}
      title={event.title}
      description={event.description}
      date={event.date}
      endTime={event.endTime}
      name={event.name}
      pictures={event.picture}
      link={event.link}
      subDescription={event.subDescription}
      staticText={staticText}
    />
  ));

const EventsWrapper = forwardRef(
  (
    {
      currentEvents,
      upcomingEvents,
      previousEvents,
      registerItemRef,
      staticText,
    },
    ref,
  ) => (
    <div ref={ref} className="events-wrapper">
      <h1 className="events-wrapper__title">{staticText.sidebarEvents}</h1>

      {!!currentEvents.length && (
        <EventsList
          shouldExpandByDefault
          evtType={staticText.eventCurrentEvent}
          arr={currentEvents}
          registerItemRef={registerItemRef}
          staticText={staticText}
        />
      )}
      {!!upcomingEvents.length && (
        <EventsList
          shouldExpandByDefault
          evtType={staticText.eventCurrentUpcommingEvent}
          arr={upcomingEvents}
          registerItemRef={registerItemRef}
          staticText={staticText}
        />
      )}
      {!!previousEvents.length && (
        <EventsList
          evtType={staticText.eventPreviousEvent}
          arr={previousEvents}
          registerItemRef={registerItemRef}
          staticText={staticText}
        />
      )}
    </div>
  ),
);

EventsWrapper.propTypes = {
  currentEvents: array,
  upcomingEvents: array,
  previousEvents: array,
  registerItemRef: func.isRequired,
  staticText: object,
};

EventsWrapper.defaultProps = {
  currentEvents: [],
  upcomingEvents: [],
  previousEvents: [],
  staticText: {},
};

export default EventsWrapper;
